'use strict';
/* ==========================================================================
   core-local/hooks.js — this lesson's hooks into the shared engine v2 (core/game.js reads window.LessonHooks).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js).
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   completeCard(stepId, progress): the PUBLISHED card: the finished step's card.done + where to go next. lesson.json's
             steps[].card.next describes the step AFTER that step, so the next line is the card.next of the step just
             before the first unpublished one (the engine's default reads the unpublished step's own card.next).
   Puppets (DESIGN.md §3): nia (poses nia, nia_point) stands LEFT, park (park, park_point) stands RIGHT. The pose
            aliases resolve at DRAW time: the pointing cut-out when it is loaded, else the standing one (else the
            engine's paper stand-in). Facing (Puppet.NATIVE, assets/ASSETS.md): nia, park and park_point (a pen raised)
            face the front (0, never mirrored); nia_point points to the viewer's LEFT (-1), so with Nia drawn facing +1
            (she stands left) she is mirrored and points right, at Ms. Park.
   ========================================================================== */
window.LessonHooks = {
  speakers: { nia: { name: 'Nia', color: '#d9352c' }, park: { name: 'Ms. Park', color: '#2b4a8c' } },
  completeCard(stepId, progress) {
    const L = (window.Game && Game.lesson) || {}, steps = L.steps || [], C = L.completeCard || {}, st = progress.stamps || {};
    const me = steps.find(s => s.id === stepId) || {};
    const done = (me.card && me.card.done) || 'Published.';
    const k = steps.findIndex(s => !st[s.id]);
    let next;
    if (k < 0) next = C.allDone || 'All four published! Lesson complete.';
    else {
      const prev = steps[k - 1];
      next = prev && prev.card && prev.card.next && prev.id === stepId ? prev.card.next
        : `Next: ${steps[k].title || steps[k].id} (page ${k + 1}).`;
    }
    return { title: C.title || 'PUBLISHED', lines: [done, next] };
  },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; DEFAULT = the standing pose), resolved per draw */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  const has = n => typeof IMG !== 'undefined' && !!IMG[n];
  const pick = (...names) => names.find(has) || names[names.length - 1];
  const poses = (me, point) => {
    const o = { [me]: me };
    Object.defineProperty(o, 'point', { enumerable: true, get: () => pick(point, me) });
    Object.defineProperty(o, point, { enumerable: true, get: () => pick(point, me) });
    return o;
  };
  P.POSES.nia = poses('nia', 'nia_point');
  P.POSES.park = poses('park', 'park_point');
  P.DEFAULT.nia = 'nia';
  P.DEFAULT.park = 'park';
  Object.assign(P.NATIVE, { nia: 0, nia_point: -1, park: 0, park_point: 0 });
})();
